// @owners { team: patients-team }
import { InputText } from '@alto/design-system';
import React from 'react';

type Props = {
  error?: string;
  onBlur?: () => void;
  onChange: (value: string) => void;
  value: string;
};

export const InsuranceBinInput = ({ error, onBlur, onChange, value }: Props) => {
  return (
    <InputText
      autoCorrect={false}
      caption="6 Digit Number"
      error={error}
      id="bin"
      keyboardType="numeric"
      label="Rx BIN"
      onBlur={onBlur}
      onChangeText={onChange}
      placeholder="000000"
      required
      value={value}
    />
  );
};
